import { render, staticRenderFns } from "./ComposicaoFamiliar.vue?vue&type=template&id=59d101d6&"
import script from "./ComposicaoFamiliar.vue?vue&type=script&lang=js&"
export * from "./ComposicaoFamiliar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports